module.exports = __webpack_public_path__ + "images/switch-off-65c53155.svg";